import { z } from 'zod';
/**
 * The name a booking is made under (doc 65 B2) — ONE rule for every new write:
 * the assistant's tool arguments, the booking domain and the owner's manual
 * form. Stored appointments and clients already cap it at 120 characters.
 *
 * Deliberately permissive about WHAT a name looks like: any script, a single
 * letter, hyphens and apostrophes are names ("Ó", "Anna-Maria", "O'Neil",
 * "Андрій"). It refuses only what cannot be a name at all: nothing, blank
 * space, text with no letter or digit, line breaks or control characters,
 * and anything longer than the stored limit. A valid string still does not
 * prove the caller said it — that is the conversation's job.
 */
export const MAX_CUSTOMER_NAME_LENGTH = 120;
const CONTROL = /[\u0000-\u001f\u007f-\u009f\u2028\u2029]/u;
const SOMETHING = /[\p{L}\p{N}]/u;
export const CustomerNameSchema = z
    .string()
    .trim()
    .min(1)
    .max(MAX_CUSTOMER_NAME_LENGTH)
    .refine((s) => !CONTROL.test(s) && SOMETHING.test(s), { message: 'Not a name.' });
/** The one runtime check (never reflects the value back in its result). */
export function checkCustomerName(raw) {
    if (raw === undefined || raw === null)
        return { ok: false, reason: 'customer_name_required', detail: 'missing' };
    if (typeof raw !== 'string')
        return { ok: false, reason: 'invalid_customer_name', detail: 'not_text' };
    const name = raw.trim();
    if (name.length === 0)
        return { ok: false, reason: 'customer_name_required', detail: 'blank' };
    if (name.length > MAX_CUSTOMER_NAME_LENGTH)
        return { ok: false, reason: 'invalid_customer_name', detail: 'too_long' };
    if (CONTROL.test(name) || !SOMETHING.test(name))
        return { ok: false, reason: 'invalid_customer_name', detail: 'not_a_name' };
    return { ok: true, name };
}
/** Is a stored display name usable to greet and book with (legacy records may not be)? */
export function usableCustomerName(raw) {
    const c = checkCustomerName(raw);
    return c.ok ? c.name : null;
}
//# sourceMappingURL=customerName.js.map